import React, { useState } from 'react'
import ModelComponent from '../../../components/Modal'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import FormikControl from '../../../components/FormikControl'
import { _integerRegex_ } from '../../../lib/Regex'
import axiosProvider from '../../../lib/AxiosProvider'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { _exception } from '../../../lib/exceptionMessage'
import {
  encodedSearchText,
  fetchOrderData,
  showToast
} from '../../../lib/AllGlobalFunction'

const PackOrder = ({
  modalShow,
  setModalShow,
  getOrderItems,
  setLoading,
  initialValues,
  setInitialValues,
  initVal,
  setToast,
  toast,
  filterDetails
}) => {
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()
  const validationSchema = Yup.object().shape({
    noOfPackage: Yup.string().required('Please enter number of packages')
  })

  const onSubmit = async (values) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'POST',
        endpoint: 'ManageOrder/OrderPackage',
        data: values,
        location: location?.pathname,
        userId
      })
      setLoading(false)
      if (response?.status === 200) {
        setModalShow({ show: false, type: '', data: null })

        const order = await fetchOrderData(
          `?searchText=${encodedSearchText(
            filterDetails?.searchText
          )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
            filterDetails?.pageSize
          }`,
          toast,
          setToast
        )

        if (order?.status === 200) {
          setInitialValues({
            ...initialValues,
            pack: { ...initialValues, orderItemIDs: [] }
          })
          getOrderItems(values?.orderID, order?.data?.data)
        }

        showToast(toast, setToast, response)
      }
    } catch {
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  return (
    <ModelComponent
      show={modalShow?.show}
      modalsize={'md'}
      modalheaderclass={''}
      className='modal-backdrop'
      modeltitle={'Pack order details'}
      onHide={() => {
        setInitialValues(initVal)
        setModalShow({ show: !modalShow?.show, data: null, type: '' })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
      formbuttonid={'package'}
      submitname={'Pack item'}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues?.pack}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, errors }) => (
          <Form id='package'>
            <div className='row align-items-center'>
              <div className='col-md-6'>
                <div className='input-wrapper mb-3'>
                  <FormikControl
                    control='input'
                    isRequired
                    label='Number of package'
                    type='text'
                    name='noOfPackage'
                    placeholder='Number of package'
                    onChange={(event) => {
                      const inputValue = event.target.value
                      const fieldName = event?.target?.name
                      const isValid = _integerRegex_.test(inputValue)
                      if (isValid || !inputValue) {
                        setFieldValue([fieldName], inputValue)
                      }
                    }}
                    maxLength={5}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ModelComponent>
  )
}

export default PackOrder
